function HomeCleanRequestTransformer(Util, jsonMapper) {

	function transform(intermediateRequest, userInput) {

		delete intermediateRequest.homeForm;

		// var bike = intermediateRequest.motorcycles[0];
		 var policyHolders = intermediateRequest.policyHolders;
		 if(policyHolders){
		 	policyHolders.forEach(function(holder,idx){
		 		if(holder.contact)
		 		{
						//Address
						if(holder.contact.address) delete holder.contact.address;

						//Contact Number
						if(holder.contact.contactNumber) delete holder.contact.contactNumber;

						//Phone number items
						cleanPolicyHoldersPhoneNumber(holder.contact.primaryPhone,holder.contact);

						//same as postal address object
						if(holder.contact.personContactSamePostalAddress!==undefined) delete holder.contact.personContactSamePostalAddress;
						if(holder.contact.additionalContactSamePostalAddress!==undefined) delete holder.contact.additionalContactSamePostalAddress;

						//10 years offences objects
						if(holder.contact.tenYears_chargedOrConvictedOffences!== undefined) delete holder.contact.tenYears_chargedOrConvictedOffences;
						if(holder.contact.tenYears_chargedOrConvictedOffencesDetails!== undefined) delete holder.contact.tenYears_chargedOrConvictedOffencesDetails;

						if(holder.contact.dwellingHistory && holder.contact.dwellingHistory.length>0){
							holder.contact.dwellingHistory.forEach(function(history,idx){

							// 	if(history.pattern.label) delete history.pattern.label;
							// 	if(history.pattern.value) delete history.pattern.value;
							// 	if(history.pattern.$$hashKey) delete history.pattern.$$hashKey;
							});
						}else{
							if(holder.contact.dwellingHistory) delete holder.contact.dwellingHistory;
						}

						//Contents from Additional
						if(holder.contact._aggregator) delete holder.contact._aggregator;
						if(holder.contact._HTMLID) delete holder.contact._HTMLID;
						if(holder.contact.$$hashKey) delete holder.contact.$$hashKey;

						if(holder.contact.authorisedPersons
							&& holder.contact.authorisedPersons!=null
							&& holder.contact.authorisedPersons.length>0
							&& holder.contact.authorisedPersons[0].person){
							if(holder.contact.authorisedPersons[0].person.companyContactSamePostalAddress!==undefined)
								delete holder.contact.authorisedPersons[0].person.companyContactSamePostalAddress

						}

						// if(holder.contact.dateOfBirth!==undefined)
						// 	delete holder.contact.dateOfBirth;
						// if(holder.contact.hasConviction!==undefined)
						// 	delete holder.contact.hasConviction;

						// if(holder.contact.dwellingHistory!==undefined)
						// 	delete holder.contact.dwellingHistory;
		 		}

		 	});
		 }

		 delete intermediateRequest.dwellings[0].location.enrichment ;
		 delete intermediateRequest.policyAddress.enrichment ;
		 delete intermediateRequest.policyHolders[0].contact.primaryAddress.enrichment ;

		return intermediateRequest;
	}

	function cleanPolicyHoldersPhoneNumber(phoneType,contactInfo){
		if(['home','mobile'].indexOf(phoneType)>-1){
			if(contactInfo.workPhone) { delete contactInfo.workPhone; }
		}

		if(['work','mobile'].indexOf(phoneType)>-1){
			if(contactInfo.homePhone) { delete contactInfo.homePhone; }
		}

		if(['work','home'].indexOf(phoneType)>-1){
			if(contactInfo.cellPhone) { delete contactInfo.cellPhone; }
		}
	}

	return {
		transform: transform
	}
}
